import { useEffect, useState, useRef } from "react";
import { Box, Button, TextField, Tabs, Tab, Typography, Tooltip, Drawer, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { ContentInTooltip, formatDateAndTimeMeth2 } from "../../../Components/CommonFunctions/CommonFunctions";
import { CommonGridToolBarWithFilterText, NewCommonPatientDetails } from "../../../Components/Common Components/CommonComponents";
import { ImagePaths } from "../../../Utility/ImagePaths";
// import CommonDatePicker from "../../../Components/Common Components/CommonDatePicker";
import { DateTime } from "luxon";
import Loader from '../../../Components/Loader'
import CommonValidation from "../../../Components/CommonFunctions/CommonValidation";

const ReverseInitiateBill = () => {
    const [state, setState] = useState({
        tabValue: 0,
        // Current tab
        currentUhid: "",
        currentMobileNumber: "",
        currentipNum: "",
        // Log tab
        loguhid: "",
        logMobileNumber: "",
        logipNum: "",
        // Data
        data: [],
        logData: [],
        logLoaded: false,
        // Toast messages
        isErrorMsg: false,
        isErrorMsgText: "",
        successMsg: false,
        successMsgText: "",
        // Pagination
        page: 0,
        pageSize: 10,
        // Date filter
        FromDate: "",
        ToDate: "",
        DateIndex: 0,
        // Loader
        isLoading: false,
        filterOpen: false,
    });

    const updateState = (data) => {
        setState((prev) => ({
            ...prev,
            ...data
        }))
    }

    // Function to close toast messages
    const msgClose = () => {
        updateState({
            isErrorMsg: false,
            isErrorMsgText: "",
            successMsg: false,
            successMsgText: "",
        })
    };

    const showErrorToast = (message) => {
        updateState({
            isErrorMsg: true,
            isErrorMsgText: message,
            successMsg: false,
            successMsgText: "",
        })
    };

    const showSuccessToast = (message) => {
        updateState({
            isErrorMsg: false,
            isErrorMsgText: "",
            successMsg: true,
            successMsgText: message,
        })
    };

    // Drawer handlers
    const handleOpenFilter = () => { updateState({ filterOpen: true }) };
    const handleCloseFilter = () => { updateState({ filterOpen: false }) };

    useEffect(() => {
        if (state.tabValue === 1) {
            fetchLogData();
        } else {
            fetchCurrentData();
        }
    }, [state.tabValue]);

    const fetchCurrentData = async (params = {}) => {
        const { patient_account_number, mobile_number } = params;
        msgClose();
        updateState({ isLoading: true });
        try {
            const response = await RestAPIService.getAll(Serviceurls.IP_REVERT_INITIATED_BILL_REQUEST + `?get_type=${"initated_ip_bill"}&uhid=${patient_account_number || ""}&mobile_number=${mobile_number || ""}`)
            if (response.data.status === 'success') {
                updateState({
                    data: response.data.data || [],
                    filterOpen: false
                });
            } else {
                showErrorToast(response.data.message);
                updateState({ data: [] });
            }
        } catch (e) {
            showErrorToast(e?.response?.data?.message || e?.message);
            updateState({ data: [] });
        } finally {
            updateState({ isLoading: false });
        }
    }

    const fetchLogData = async (params = {}) => {
        const { patient_account_numberL, mobile_numberL } = params;
        msgClose();
        updateState({ logLoaded: true });
        try {
            // const response = await RestAPIService.getAll(Serviceurls.IP_REVERT_INITIATED_BILL_REQUEST + `?get_type=${"initated_ip_bill"}&uhid=${patient_account_numberL || ""}&mobile_number=${mobile_numberL || ""}&from_date=${state.FromDate || ""}&to_date=${state.ToDate || ""}&status=completed`)
            const response = await RestAPIService.getAll(Serviceurls.IP_REVERT_INITIATED_BILL_REQUEST + `?get_type=${"initated_ip_bill"}&uhid=${patient_account_numberL || ""}&mobile_number=${mobile_numberL || ""}&status=completed`)
            if (response.data.status === "success") {
                updateState({
                    logData: response.data.data || [],
                    filterOpen: false
                });
            } else {
                showErrorToast(response.data.message);
                updateState({ logData: [] });
            }
        } catch (e) {
            showErrorToast(e?.response?.data?.message || e?.message);
            updateState({ logData: [] });
        } finally {
            updateState({ logLoaded: false });
        }
    };

    const handleTabChange = (e, newValue) => {
        updateState({
            tabValue: newValue,
            ...(newValue === 0
                ? {
                    loguhid: "",
                    logMobileNumber: "",
                    logipNum: "",
                }
                : {
                    currentUhid: "",
                    currentMobileNumber: "",
                    currentipNum: "",
                }),
        });
    };

    const handleSearch = async () => {
        try {
            let params = {
                //CURRENT TAB
                patient_account_number: state.currentUhid.trim(),
                mobile_number: state.currentMobileNumber.trim(),
                //LOG TAB
                patient_account_numberL: state.loguhid.trim(),
                mobile_numberL: state.logMobileNumber.trim()
            };

            if (state.tabValue === 0) {
                await fetchCurrentData(params);
            } else {
                await fetchLogData(params);
            }
        } catch (err) {
            showErrorToast(err?.response?.data?.message || err?.message);
            if (state.tabValue === 0) updateState({ data: [] });
            else updateState({ logData: [] });
        } finally {
            updateState({ isLoading: false });
        }
    };

    const handleClear = async () => {
        updateState({
            currentUhid: "",
            currentMobileNumber: "",
            currentipNum: "",
            loguhid: "",
            logMobileNumber: "",
            logipNum: "",
            isErrorMsg: false,
            isErrorMsgText: "",
            successMsg: false,
            successMsgText: "",
            FromDate: "",
            ToDate: "",
            DateIndex: 0
        });

        // CALL API BASED ON CURRENT TAB
        if (state.tabValue === 0) {
            await fetchCurrentData({
                patient_account_number: "",
                mobile_number: ""
            });
        } else {
            await fetchLogData({
                patient_account_numberL: "",
                mobile_numberL: ""
            });
        }
    };


    const handleReverseInitiate = async (rowData) => {
        updateState({ isLoading: true });

        const payload = {
            revert_id: rowData.revert_id,
            ip_admission_id: rowData.ip_admission_id,
        };
        try {
            const response = await RestAPIService.create(payload, Serviceurls.IP_REVERT_INITIATED_BILL_REQUEST);
            if (response.data.status === "success") {
                showSuccessToast(response?.data?.message)
                fetchCurrentData({}, true);
            } else {
                showErrorToast(response.data.message);
            }
        } catch (error) {
            showErrorToast(error?.response?.data?.message || error.message);
        } finally {
            updateState({ isLoading: false });

        }
    };

    const columnsCurrent = [
        {
            field: "patient_name",
            headerName: "Patient Details",
            flex: 0.22,
            renderCell: (params) => {
                return (
                    <NewCommonPatientDetails data={params.row} />
                );
            },
        },
        {
            field: "ip_number", headerName: "Admission No", flex: 0.16,
            renderCell: (params) => (<Box component={'div'}>{ContentInTooltip(params?.row?.ip_number, 22)}</Box>)
        },
        {
            field: "request_details", headerName: "Request Details", flex: 0.16,
            valueGetter: (params) => {
                const name = params.row?.created_user?.created_by_name || "";
                const date = params.row?.created_date
                    ? formatDateAndTimeMeth2(params.row.created_date)
                    : "";

                return `${name} ${date}`;
            },
            renderCell: (params) => {
                const { created_user } = params.row || {};
                return (
                    <Box>
                        <Typography fontSize={"0.8vw"} fontWeight={600}>{ContentInTooltip(created_user?.created_by_name, 15)}</Typography>
                        <Typography fontSize={"0.8vw"}>{(params?.row?.created_date ? formatDateAndTimeMeth2(params?.row?.created_date) : "-")}</Typography>
                    </Box>)
            }
        },
        {
            field: "remarks", headerName: "Reason", flex: 0.16,
            renderCell: (params) => {
                const { remarks } = params.row || {};
                return (
                    <Box display="flex" alignItems="center" gap={1} justifyContent={"center"}>
                        <Box>
                            <Typography >{ContentInTooltip(remarks, 35) || '-'} </Typography>
                        </Box>
                    </Box>
                );
            },
        },
        {
            field: "action",
            headerName: "Action",
            headerAlign: "center",
            align: "center",
            flex: 0.10,
            renderCell: (params) => (
                <Button
                    size="small"
                    variant="contained"
                    onClick={() => handleReverseInitiate(params.row)}
                    disabled={state.isLoading}
                    justifyContent={"center"}
                >
                    Revert
                </Button>
            ),
        },
    ];

    const columnsLog = [
        {
            field: "patient_name",
            headerName: "Patient Details",
            flex: 0.18,
            renderCell: (params) => {
                return (
                    <NewCommonPatientDetails data={params.row} />
                );
            },
        },
        {
            field: "ip_number", headerName: "Admission No", flex: 0.16,
            renderCell: (params) => (<Box component={'div'}>{ContentInTooltip(params?.row?.ip_number, 22)}</Box>)
        },
        {
            field: "remarks", headerName: "Reason", flex: 0.14,
            renderCell: (params) => {
                const { remarks } = params.row || {};
                return (
                    <Box display="flex" alignItems="center" gap={1} justifyContent={"center"}>
                        <Box>
                            <Typography >{ContentInTooltip(remarks, 30) || '-'} </Typography>
                        </Box>
                    </Box>
                );
            },
        },
        {
            field: "request_details", headerName: "Request Details", flex: 0.16,
            valueGetter: (params) => {
                const name = params.row?.created_user?.created_by_name || "";
                const date = params.row?.created_date
                    ? formatDateAndTimeMeth2(params.row.created_date)
                    : "";

                return `${name} ${date}`;
            },
            renderCell: (params) => {
                const { created_user } = params.row || {};
                return (
                    <Box>
                        <Typography fontSize={"0.8vw"} fontWeight={600}>{ContentInTooltip(created_user?.created_by_name, 15)}</Typography>
                        <Typography fontSize={"0.8vw"}>{(params?.row?.created_date ? formatDateAndTimeMeth2(params?.row?.created_date) : "-")}</Typography>
                    </Box>)
            }
        },
        {
            field: "approved_details", headerName: "Approver Details", flex: 0.13,
            valueGetter: (params) => {
                const name = params.row?.approved_by || "";
                const date = params.row?.approved_date
                    ? formatDateAndTimeMeth2(params.row.approved_date)
                    : "";

                return `${name} ${date}`;
            },
            renderCell: (params) => (
                <Box>
                    <Typography fontSize={"0.8vw"} fontWeight={600}>{ContentInTooltip(params?.row?.approved_by, 15)}</Typography>
                    <Typography fontSize={"0.8vw"}>{(params?.row?.approved_date ? formatDateAndTimeMeth2(params?.row?.approved_date) : "-")}</Typography>
                </Box>)
        },
    ];

    const gridToolBar = () => {
        return (
            <Box>
                <CommonGridToolBarWithFilterText />
            </Box>
        )
    }

    const handleDateChange = (fromDate, toDate, dateIndex) => {
        const today = DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd');
        updateState({
            FromDate: dateIndex === 1 ? today : fromDate,
            ToDate: dateIndex === 1 ? today : toDate,
            DateIndex: dateIndex,
        })
    };

    const renderTextField = (label, stateKey, maxLength = null) => {
        return (
            <TextField
                label={label}
                size="small"
                autoComplete="off"
                inputProps={maxLength ? { maxLength } : {}}
                value={state[stateKey]}
                onChange={(e) => {
                    const value = e.target.value;
                    if (label !== "Mobile Number" || (CommonValidation.numberOnly(value) || (value === ""))) {
                        updateState({ [stateKey]: value })
                    }
                }}
                disabled={state.isLoading}
            />
        )
    }

    const Filter = () => {
        return (
            <Box component={"div"} className='eMed_Filter_Billing_Container'>
                <Box component={"div"} className='eMed_Filter_Top'>
                    <Typography variant='h6' fontWeight={"600"}>{"Filter"}</Typography>
                    <Button onClick={() => { handleCloseFilter() }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <br></br>
                <Box component={"div"} >
                    {state.tabValue === 0 ? (
                        <Box display="flex" flexDirection={'row'} gap={2} mb={2} sx={{ marginLeft: '1vw' }}>
                            {renderTextField("UHID", "currentUhid", 25)}
                            {renderTextField("Mobile Number", "currentMobileNumber", 10)}
                        </Box>
                    ) : (
                        <Box display="flex" flexDirection={'column'} justifyContent={'flex-end'} gap={2} mb={2} alignItems={'flex-end'} marginRight={"1vw"}>
                            {/* <Box style={{ width: "40%", }} component={"div"}>
                                <CommonDatePicker
                                    FromDate={state.FromDate}
                                    ToDate={state.ToDate}
                                    DateIndex={state.DateIndex}
                                    SelectedDates={handleDateChange}
                                />
                            </Box> */}
                            <Box display="flex" flexDirection={'row'} gap={2} mb={2} sx={{ marginLeft: '1vw' }}>
                                {renderTextField("UHID", "loguhid", 25)}
                                {renderTextField("Mobile Number", "logMobileNumber", 10)}
                            </Box>
                        </Box>
                    )}

                    {/* clear and search button */}
                    <Box component={"div"} className="eMed_Filter_Btn_Div">
                        <Stack direction="row" spacing={2} mt={2}>

                            <Button variant="outlined" onClick={handleClear} sx={{textTransform: "capitalize"}} disabled={state.isLoading || state.logLoaded}>
                                Clear
                            </Button>
                            <Button variant="contained" onClick={handleSearch} sx={{textTransform: "capitalize"}} disabled={state.isLoading || state.logLoaded}>
                                Search
                            </Button>
                        </Stack>
                    </Box>
                </Box>
            </Box>
        )
    };

    return (
        <Box>
            {/* Toast Messages */}
            {state.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={state.isErrorMsgText}
                    msgPop={msgClose} /> : null}
            {!state.isErrorMsg && state.successMsg &&
                <ToastMsg
                    severity={'success'}
                    msg={state.successMsgText}
                    msgPop={msgClose} />}


            <Box display={'flex'} justifyContent={'space-between'}>
                {/* Tabs */}
                <Tabs value={state.tabValue} onChange={handleTabChange}>
                    <Tab label="Pending" disabled={state.isLoading} sx={{ textTransform: 'capitalize', minHeight: '1vw', fontWeight: 600 }} />
                    <Tab label="Completed" disabled={state.isLoading} sx={{ textTransform: 'capitalize', minHeight: '1vw', fontWeight: 600 }} />
                </Tabs>

                <Box component="div" className="eMed_Filter_Icon_div" sx={{ marginTop: "1dvh" }}>
                    <Tooltip title="Filter" placement="top" arrow>
                        <Button className="eMed_usrconf_btn" onClick={handleOpenFilter}>
                            <img src={ImagePaths.Filter.default} alt="filter" className="eMed_action_img" />
                        </Button>
                    </Tooltip>
                </Box>

            </Box>

            <Loader loaderOpen={state.isLoading} />
            <div style={{ height: '72dvh', width: '100%' }}>
                <DataGrid
                    rows={state.tabValue === 0 ? state.data : state.logData}
                    columns={state.tabValue === 0 ? columnsCurrent : columnsLog}
                    getRowId={(row) => row.revert_id}
                    getRowHeight={() => 70}
                    density="compact"
                    onPageChange={(newPage) => { updateState({ page: newPage }) }}
                    onPageSizeChange={(newPageSize) => { updateState({ pageSize: newPageSize }) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    page={state.page}
                    pageSize={state.pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                />
            </div>
            <Drawer
                anchor="right"
                open={state.filterOpen}
                onClose={handleCloseFilter}
            >
                {Filter()}
            </Drawer>

        </Box>
    );
};

export default ReverseInitiateBill;